import { FormControl, styled } from '@mui/material';

export const StyledFormControl = styled(FormControl)({
  display: 'block',
  '& .MuiOutlinedInput-root': { backgroundColor: '#fff' },
  '& .MuiCircularProgress-root': {
    width: '20px !important',
    height: '20px !important',
  },
  '& .MuiPaper-root': {
    borderRadius: '4px',
    marginTop: '8px',
    boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)',
  },
});